import { createFileRoute } from '@tanstack/react-router'
import { KnowledgeBasePage } from '@/features/incidents/knowledge-base'

// The Incident Knowledge Base now lives with the other incident settings. The old
// /incidents/knowledge-base address redirects here.
export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/incident-knowledge-base'
)({
  component: KnowledgeBasePage,
})
